/**
 * External links
 *	Append icon to all external links and ensure they open in a new tab
 */
const ExternalLinks = () => {
  $('.element-content a').each(function () {
    var link = $(this);
    addIcon(link);
  });
}

function addIcon(a) {
  var href = a.attr('href');
  var external = true;

  // Ignore links that don't have href
  if (!href) {
    external = false;
    return;
  }

  // Ignore modal links
  if (a.hasClass('launchmodal')) {
    external = false;
    return;
  }

  // Ignore links that start with a backslash
  if (href.charAt(0) == '/') {
    external = false;
  }

  // Ignore menu links
  if (a.hasClass('secondarymenu-link')) {
    // Don't ignore links inside landingnav
    if (a.closest('.landingnav').length < 1 && a.closest('.topnav').length < 1) {
      external = false;
    }
  }

  // Ignore links in horizontal tabs
  if (a.closest('.anchornav').length > 0) {
    external = false;
  }

  // Ignore homepage link
  if (a.hasClass('header-logo')) {
    external = false;
  }

  // Ignore points of interest links, social links and pagination links
  if (a.hasClass('social-link') || a.hasClass('searchresults-pagelink') || a.hasClass('hide-external-link')) {
    external = false;
  }

  // Ignore links that contain the domain
  if (href.indexOf('nzrugby') != -1) {
    external = false;
  }

  // Ignore email links
  if (href.indexOf('mailto:') != -1) {
    external = false;
  }

  if (external) {
    a.prop('target', '_blank').addClass('externallink');
  }
}

export default ExternalLinks;
